"use client";

import Section from "../components/Section";
import { Box, MonthYearSelector, Tab, TabList, Tabs } from "@repo/ui";

import { Suspense, useEffect, useRef, useState } from "react";
import ScheduleWrapper, {
  ScheduleWrapperRef,
} from "@/components/courses/ScheduleWrapper";
import Loading from "@/components/common/Loading";

type SchedulesProps = {
  sectionInfo: PageSections;
  data: {
    heading: string;
  };
};

const Schedules = ({ data, sectionInfo }: SchedulesProps) => {
  const [modeOfTraining, setModeOfTraining] = useState("");
  const [wrapperDivHeight, setWrapperDivHeight] = useState(1314);
  const scheduleRef = useRef<ScheduleWrapperRef>(null);

  const handleDateChange = (value: string) => {
    scheduleRef.current?.refetch({ date: value });
  };

  const handleModeOfTraining = (value: string) => {
    setModeOfTraining(value);
    scheduleRef.current?.refetch({ modeOfTraining: value });
  };

  useEffect(() => {
    if (scheduleRef.current?.wrapperDivRef.current) {
      setWrapperDivHeight(
        scheduleRef.current.wrapperDivRef.current.clientHeight
      );
    }
  }, [scheduleRef.current?.wrapperDivRef?.current?.clientHeight]);

  return (
    <Section
      id={sectionInfo.sectionId}
      className={sectionInfo.sectionClass}
      data-title={sectionInfo.name}
      title={data.heading}
    >
      {/* Filters */}
      <Box className="grid sm:grid-flow-col grid-flow-row gap-3">
        <Box className="place-self-start">
          <Tabs
            onValueChange={handleModeOfTraining}
            value={modeOfTraining}
            // defaultValue={modeOfTraining}
          >
            <TabList>
              <Tab value={""}>All trainings</Tab>
              <Tab value={"138"}>Live online trainings</Tab>
              <Tab value={"139"}>Classroom trainings</Tab>
            </TabList>
          </Tabs>
        </Box>
        <Box className="sm:place-self-end place-self-start">
          <MonthYearSelector onChange={handleDateChange} />
        </Box>
      </Box>
      <Suspense
        fallback={
          <Loading
            message="Loading Schedule..."
            style={{ minHeight: wrapperDivHeight }}
          />
        }
      >
        <ScheduleWrapper ref={scheduleRef} modeOfTraining={modeOfTraining} />
      </Suspense>
    </Section>
  );
};

export default Schedules;
